import AddEditResource from "./AddEditResource/AddEditResource";
import AddEditSchoolPoc from "./AddEditSchoolPoc/AddEditSchoolPoc";

const ResourceManagementInfo = () => {

  return (
    <div className="bg-white p-5">
      <AddEditResource />
      <AddEditSchoolPoc />
    </div>
  );
};

export default ResourceManagementInfo;
